// extracted by mini-css-extract-plugin
module.exports = {"MainMenu":"MainMenu_MainMenu__3mCgv","WithChip":"MainMenu_WithChip__1YS06","Chip":"MainMenu_Chip__294M6","Badge":"MainMenu_Badge__2b_bk","Submenu":"MainMenu_Submenu__395U8"};